import { useShallow } from 'zustand/react/shallow'

import { selectWorkspaceSettingsState } from '@modules/settings/workspace/stores/workspace.selector'
import { useWorkspaceStore } from '@modules/settings/workspace/stores/workspace.store'
import {
  deleteWorkspace,
  getWorkspaceSettings,
  updateWorkspaceLogo,
  updateWorkspaceName,
} from '@modules/settings/workspace/stores/workspace.thunks'
import {
  getWorkspaceMembers,
  inviteProjectMember,
  inviteWorkspaceMember,
  removeMember,
  updateMemberRole,
} from '@modules/settings/workspace/stores/workspace-members.thunks'
import {
  getWorkspaceNotifications,
  updateWorkspaceNotificationChannel,
  updateWorkspaceNotificationGroup,
} from '@modules/settings/workspace/stores/workspace-notifications.thunks'

export function useWorkspaceSettings() {
  const { workspace, members, notifications, loading, error, clearError } = useWorkspaceStore(
    useShallow(selectWorkspaceSettingsState)
  )

  return {
    workspace,
    members,
    notifications,
    loading,
    error,
    getWorkspaceSettings,
    updateWorkspaceName,
    updateWorkspaceLogo,
    deleteWorkspace,
    getWorkspaceMembers,
    getWorkspaceNotifications,
    inviteProjectMember,
    inviteWorkspaceMember,
    removeMember,
    updateMemberRole,
    updateWorkspaceNotificationChannel,
    updateWorkspaceNotificationGroup,
    clearError,
  }
}
